import React from "react";
import { Image } from "@chakra-ui/react";

interface Props {
  src: string;
  alt: string;
  // 원본 픽셀 크기 — img의 width/height 속성으로 넘겨 로딩 중 레이아웃이 밀리지 않게 한다.
  naturalWidth: number;
  naturalHeight: number;
  // 첫 화면(히어로)만 즉시 로드하고 나머지는 지연 로드한다.
  isEager?: boolean;
}

/**
 * 랜딩의 상품 카드 이미지.
 *
 * 카드 UI를 직접 만들지 않고 시안 이미지를 그대로 쓴다 — 앱의 실제 카드와 갈라지지 않게 하기 위해서다.
 * 이미지 한 장이 카드 한 장이 아니라 **한 영역(2장 또는 3장 묶음)** 이다.
 */
function PathPickLandingProductImage({
  src,
  alt,
  naturalWidth,
  naturalHeight,
  isEager = false,
}: Props) {
  return (
    <Image
      src={src}
      alt={alt}
      width={naturalWidth}
      height={naturalHeight}
      loading={isEager ? "eager" : "lazy"}
      maxWidth={`${naturalWidth}px`}
      // 좁은 화면에서는 원본보다 작게 줄어들되 비율은 유지한다.
      sx={{ width: "100%", height: "auto" }}
    />
  );
}

export default PathPickLandingProductImage;
